module.exports = __webpack_public_path__ + "static/media/categories.1a657079.svg";